module.exports = __webpack_public_path__ + "img/defaultIcon.e45d67d1.png";